<div [ngClass]="themeService.isDarkMode() ? 'dark' : ''" class="app-container">
	@if (controlVisibilities()?.showHeader !== false) {
		<vb-lxp-header
			[accentBar]="headerConfig().accentBar"
			[centerImageSrc]="
				themeService.isDarkMode()
					? headerConfig().centerImageSrcDark
					: headerConfig().centerImageSrcLight
			"
			[centerImageAlt]="headerConfig().centerImageAlt"
			[centerText]="headerConfig().centerText"
			[logoLink]="headerConfig().logoLink"
			[logoLinkTarget]="headerConfig().logoLinkTarget"
		>
			<!-- Left section: Event info -->
			@if (raceInfo()) {
				<div header-left class="header-left-content">
					<span class="header-title">{{ raceInfo()?.champName }}</span>
					<span class="header-subtitle">| {{ raceInfo()?.eventShortName }}</span>
					<span class="header-subtitle">| {{ raceInfo()?.name }}</span>
					<vb-lxp-race-flag-indicator [raceStatus]="raceStatus()"></vb-lxp-race-flag-indicator>
					@if (isSessionArchived()) {
						<span class="header-subtitle">| No current track activity</span>
					}
				</div>
			} @else {
				<div header-left class="header-left-content">
					<span class="header-title">{{ headerConfig().raceTitle}}</span>
					<span class="header-subtitle">{{ headerConfig().raceDetail}}</span>
				</div>
			}

			<!-- Right section -->
			<div header-right class="header-right-content">
				@if ((raceInfo() || controlVisibilities().showLayoutSelectorWithoutRaceInfo) && controlVisibilities().showLayoutControls && !isSessionArchived()) {
					<div
						class="main-stream-toggle"
					(click)="
						livestreamViewService.onMainStreamToggled(
							!livestreamViewService.isMainStreamSelected()
						)
					"
				>
					<span class="main-stream-toggle-title desktop-label">Main Stream</span>
					<span class="main-stream-toggle-title mobile-label">Main</span>
					<vb-lxp-switch [checked]="livestreamViewService.isMainStreamSelected()"></vb-lxp-switch>
				</div>
				}
				@if (
					(raceInfo() || controlVisibilities().showLayoutSelectorWithoutRaceInfo) &&
					controlVisibilities().showLayoutControls &&
					controlVisibilities().showTwitchStreamControl &&
					!isSessionArchived()
				) {
					<div
						class="main-stream-toggle"
						[class.opacity-50]="!livestreamViewService.getTwitchStreamData()"
						[class.pointer-events-none]="!livestreamViewService.getTwitchStreamData()"
						(click)="
							livestreamViewService.onTwitchStreamToggled(
								!livestreamViewService.isTwitchStreamSelected()
							)
						"
					>
						<span class="main-stream-toggle-title desktop-label">Twitch Stream</span>
						<span class="main-stream-toggle-title mobile-label">Twitch</span>
						<vb-lxp-switch
							[checked]="livestreamViewService.isTwitchStreamSelected()"
							[disabled]="!livestreamViewService.getTwitchStreamData()"
						></vb-lxp-switch>
				</div>
			}
			@if (controlVisibilities().showDriverSelectControl) {
				<button class="relative btn-outlined border-surface-container-high! py-1! px-1!" [dropdownTriggerFor]="driverDropdown">Select Drivers
					<div class="w-5"></div>
					<span class="bi bi-chevron-down"></span>
				</button>

				<vb-lxp-dropdown #driverDropdown>
						@for (stream of supportStreams(); track stream) {
							<div class="flex items-center gap-4 text-nowrap mb-1 p-1 rounded hover:bg-primary-container hover:text-on-primary-container hover:cursor-pointer"
								[ngClass]="[timingTowerService.activeList().includes(stream.carNumber) ? 'bg-primary text-on-primary' : '']"
								(click)="onSpa24DriverSelected($event, stream.carNumber, stream.teamName, stream.hlsPlaybackUrl)">
									<span class="bg-primary text-on-primary w-10 rounded-md text-center px-2 py-1">{{ stream.carNumber }}</span>
									<span class="grow-1 overflow-hidden text-ellipsis ">{{ stream.teamName }}</span>
							</div>
						}
				</vb-lxp-dropdown>
			}
				@if (
					(raceInfo() || controlVisibilities().showLayoutSelectorWithoutRaceInfo) &&
					controlVisibilities().showLayoutControls &&
					!isMobile() &&
					!isSessionArchived()
				) {
					<vb-lxp-layout-selector></vb-lxp-layout-selector>
				}

				<!-- Panel Toggle Buttons - Only show on desktop/tablet -->
				<div class="header-panel-toggles">
					@if (controlVisibilities().showTimingControl && !isSessionArchived()) {
						<button
							class="header-panel-toggle timing"
							[class.active]="isTimingActive()"
							title="Toggle Live Timing"
							(click)="toggleTiming()"
						>
							<i class="bi bi-stopwatch"></i>
							<span class="toggle-label">Timing</span>
						</button>
					}
					@if (controlVisibilities().showMapControl) {
						<app-race-class
							[classes]="raceClasses()"
							(selectionChange)="onClassSelectionChange($event)"
						></app-race-class>
						<button
							class="timing px-5! py-0.5!"
							[ngClass]="isMapActive() ? 'btn-primary-filled' : 'btn-outlined'"
							title="Toggle Live Timing"
							(click)="toggleMap()"
						>
							<i class="bi bi-map mr-1"></i>
							<span class="toggle-label">Map</span>
						</button>
					}
					@if (controlVisibilities().showStreamsControl) {
						<button class="btn-outlined px-5! py-1! mr-2" (click)="openStreamPage()">
							Streams
						</button>
					}
					@if (controlVisibilities().showChatControl) {
						<button
							class="header-panel-toggle chat"
							[class.active]="isChatActive()"
							title="Toggle Twitch Chat"
							(click)="toggleChat()"
						>
							<svg fill="currentColor" viewBox="0 0 24 24">
								<path
									d="M11.571 4.714h1.715v5.143H11.57zm4.715 0H18v5.143h-1.714zM6 0L1.714 4.286v15.428h5.143V24l4.286-4.286h3.428L22.286 12V0zm14.571 11.143l-3.428 3.428h-3.429l-3 3v-3H6.857V1.714h13.714Z"
								/>
							</svg>
							<span class="toggle-label">Chat</span>
						</button>
					}
				</div>

				<!-- Themes toggle -->
				<vb-lxp-theme-toggle></vb-lxp-theme-toggle>
			</div>
		</vb-lxp-header>
	}

	@if (!isAdminRoute()) {
		<vb-lxp-notification [notification]="currentNotification()"></vb-lxp-notification>
	}

	<main class="main-content">
		<router-outlet></router-outlet>
	</main>

	@if (controlVisibilities()?.showFooter !== false) {
		<vb-lxp-footer [imagePaths]="footerImages()">
			@if (isMobile()) {
				<div footer-tabs class="mobile-panel-toggles-fixed mobile-panel-footer">
					@if (controlVisibilities().showTimingControl) {
						<button
							class="mobile-panel-btn timing"
							[class.active]="isTimingActive()"
							(click)="toggleTiming()"
						>
							<i class="bi bi-stopwatch"></i>
							<span>Timing</span>
						</button>
					}
					@if (controlVisibilities().showChatControl) {
						<button
							class="mobile-panel-btn chat"
							[class.active]="isChatActive()"
							(click)="toggleChat()"
						>
							<svg fill="currentColor" viewBox="0 0 24 24">
								<path
									d="M11.571 4.714h1.715v5.143H11.57zm4.715 0H18v5.143h-1.714zM6 0L1.714 4.286v15.428h5.143V24l4.286-4.286h3.428L22.286 12V0zm14.571 11.143l-3.428 3.428h-3.429l-3 3v-3H6.857V1.714h13.714Z"
								/>
							</svg>
							<span>Chat</span>
						</button>
					}
				</div>
			}
		</vb-lxp-footer>
	}

	@if (modalService.getModalSignal('race-control')()) {
		<div class="modal-overlay" (click)="modalService.closeModal('race-control')">
			<div class="modal-container max-h-200" (click)="$event.stopPropagation()">
				<div class="modal-header">
					<i class="bi bi-chat-left-text text-3xl text-on-surface"></i>
					<h3 class="modal-title">Race Control Messages</h3>
					<button
						type="button"
						class="modal-close"
						aria-label="Close modal"
						(click)="modalService.closeModal('race-control')"
					>
						<i class="bi bi-x-lg"></i>
					</button>
				</div>
				<div class="modal-body overflow-y-scroll max-h-100">
					@if (raceControlMessages().length) {
						<p class="modal-description">Current session race control messages:</p>
						<ul class="modal-list">
							<li *ngFor="let message of raceControlMessages()">
								<div>
									<strong>{{ message.dayTime | date: 'short' }}: </strong>
									<br />
									<span>{{ message.groupText }} - {{ message.text }}</span>
								</div>
							</li>
						</ul>
					} @else {
						<p class="modal-description">No race control messages logged</p>
					}
				</div>
				<div class="modal-footer">
					<button
						(click)="modalService.closeModal('race-control')"
						type="button"
						class="modal-btn-secondary"
					>
						Close
					</button>
				</div>
			</div>
		</div>
	}
</div>
